import { useEffect, useState } from "react";
import {
  FiStar,
  FiArrowUpCircle,
  FiClock,
  FiArrowDownLeft,
  FiCheckCircle,
  FiXCircle,
} from "react-icons/fi";
import api from "../../services/api";

const IncentiveSummary = ({ refreshKey = 0 }) => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const token = localStorage.getItem("rmc2.access_token");
        if (!token) {
          return;
        }

        const response = await api.get("/dashboard/incentive-summary", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data?.status !== "success") {
          return;
        }

        setSummary(response.data?.data || null);
      } catch (error) {
        return;
      }
    };

    fetchSummary();
  }, [refreshKey]);

  const formatAmount = (value) => {
    const amount = Number(value);
    if (Number.isNaN(amount)) {
      return "₱ 0.00";
    }
    return new Intl.NumberFormat("en-PH", {
      style: "currency",
      currency: "PHP",
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("₱", "₱ ");
  };

  const incentiveCards = [
    {
      title: "Total",
      value: formatAmount(summary?.total_amount || 0),
      icon: FiStar,
      cardClass: "bg-amber-50 border-amber-200",
      badgeClass: "bg-amber-500",
      levelKey: "total",
    },
    {
      title: "Released",
      value: formatAmount(summary?.released_amount || 0),
      icon: FiArrowUpCircle,
      cardClass: "bg-emerald-50 border-emerald-200",
      badgeClass: "bg-emerald-500",
      levelKey: "released",
    },
    {
      title: "Requested",
      value: formatAmount(summary?.requested_amount || 0),
      icon: FiClock,
      cardClass: "bg-sky-50 border-sky-200",
      badgeClass: "bg-sky-500",
      levelKey: "requested",
    },
    {
      title: "For Request",
      value: formatAmount(summary?.available_amount || 0),
      icon: FiArrowDownLeft,
      cardClass: "bg-indigo-50 border-indigo-200",
      badgeClass: "bg-indigo-500",
      levelKey: "available",
    },
    {
      title: "Valid Commissions",
      value: formatAmount(summary?.valid_amount || 0),
      icon: FiCheckCircle,
      cardClass: "bg-emerald-50 border-emerald-200",
      badgeClass: "bg-emerald-500",
      levelKey: "valid",
    },
    {
      title: "Invalid Commissions",
      value: formatAmount(summary?.invalid_amount || 0),
      icon: FiXCircle,
      cardClass: "bg-rose-50 border-rose-200",
      badgeClass: "bg-rose-500",
      levelKey: "invalid",
    },
  ];

  return (
    <div className="rounded-3xl border border-white/60 bg-white/90 p-6 shadow-lg shadow-slate-200/60">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-400">
            Rewards
          </p>
          <h2 className="mt-1 text-2xl font-semibold text-slate-900">
            Incentive Summary
          </h2>
        </div>
        <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500">
          Monthly Cycle
        </span>
      </div>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {incentiveCards.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.title}
              className={`summary-card rounded-2xl border px-5 py-4 ${card.cardClass}`}
            >
              <div className="flex items-center gap-3 text-slate-700">
                <span
                  className={`summary-badge flex h-9 w-9 items-center justify-center rounded-full text-white ${card.badgeClass}`}
                >
                  <Icon />
                </span>
                <p className="summary-title text-sm font-semibold">{card.title}</p>
              </div>
              <p className="summary-value mt-4 text-3xl font-semibold text-slate-900">
                {card.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IncentiveSummary;
